<template>
  <base-dialog
    :action="onAction"
    :action-name="'Add'"
    :close="onClose"
    :title="'Add a product'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="filter"
            label="Search"
            class="mb-3"
            prepend-inner-icon="search"
            block
            outlined
            hide-details
            clearable
          />

          <v-alert
            dense
            outlined
            text
            color="info"
            icon="info"
          >
            Only showing products with matching currency:
            ({{ currency }})
          </v-alert>

          <v-layout
            v-if="isLoading"
            align-center
            justify-center
            row
            fill-height
          >
            <v-progress-circular
              :size="125"
              :width="10"
              color="primary"
              indeterminate
            />
          </v-layout>

          <v-layout v-if="!isLoading">
            <v-flex xs12>
              <v-list>
                <template
                  v-for="(product, index) in items"
                >
                  <v-list-group
                    v-if="productVariants(product.id).length > 0"
                    :key="`product_${index}`"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>{{ product.label }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ productVariants(product.id).length }} variants
                      </v-list-item-subtitle>
                    </template>

                    <v-list-item-group
                      v-model="selectedVariants"
                      multiple
                    >
                      <template
                        v-for="(variant, variantIndex) in productVariants(product.id)"
                      >
                        <v-list-item
                          :disabled="variant.isExcluded === true"
                          :key="`variant_${variantIndex}`"
                          :value="variant"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{ variant.sku }}</v-list-item-title>
                            <v-list-item-subtitle>{{ optionsToText(product.id, variant.options) }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-chip
                              v-if="variant.isExcluded === true"
                              small
                              outlined
                            >
                              Excluded
                            </v-chip>
                          </v-list-item-action>
                          <v-list-item-action v-if="variant.isExcluded !== true">
                            <span class="grey--text">Qty:</span>{{ variant.quantity }}
                          </v-list-item-action>
                          <v-list-item-action v-if="variant.isExcluded !== true">
                            <span v-money="{ amount: variant.amount, currency: 'cad' }" />
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list-group>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import BaseDialog from "../Common/BaseDialog"
import { readablePlanTerms } from '../../services/stripe.service'

export default {
  components: { BaseDialog },
  props: {
    currency: {
      type: String,
      default: ''
    },
    addedIds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters([
      'getUnarchivedProducts',
      'allProducts',
      'getVariantsForProduct',
      'getVariantsByProduct',
      'allProductVariants',
      'getProductOptionLabel'
    ]),
    items() {
      const products = this.allProducts

      products.forEach(p => {
        const payload = { productId: p.id }
        this.initVariantsForProduct(payload)
      })

      return products
    },
    productVariants() {
      return (productId) =>
        this.getVariantsByProduct(productId)
        .filter(v => v.isExcluded !== true)
    }
  },
  data() {
    return {
      filter: '',
      isLoading: false,
      selectedVariants: [],
    }
  },
  async mounted() {
    this.initProducts()
  },
  methods: {
    ...mapActions([ 'listPlans', 'initProducts', 'initVariantsForProduct' ]),
    _get(obj, path, defaultVal) {
      return get(obj, path, defaultVal)
    },
    onClose() {
      this.$emit('close')
    },
    isIdAdded(id) {
      return this.addedIds.includes(id)
    },
    optionsToText(productId, options) {
      const textOptions= []
      for (const [ key, option ] of Object.entries(options)) {
        textOptions.push(`${this.getProductOptionLabel(productId, key)}: ${option.value}`)
      }

      return textOptions.join(', ')
    },
    onAction() {
      this.$emit('action', this.selectedVariants)

      this.selectedVariants = []
    }
  }
}
</script>
